// extracted by mini-css-extract-plugin
export default {"photoGrid":"photogallery_photoGrid__g9AzX"};